import { render } from "./HotspotLogoTips.vue?vue&type=template&id=55e07ba4&scoped=true&ts=true"
import script from "./HotspotLogoTips.vue?vue&type=script&lang=ts"
export * from "./HotspotLogoTips.vue?vue&type=script&lang=ts"

import "./HotspotLogoTips.vue?vue&type=style&index=0&id=55e07ba4&scoped=true&lang=scss"

import exportComponent from "/data/.jenkins/workspace/k8s-shouba-exhibitionhall-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55e07ba4"]])

export default __exports__